import React from 'react';

const Founder = () => {
  return (
    <>
    <section id="founder" className="container mb-5 founder-page">
        
      <h2 className="heading">Founder</h2>

      {/* <h5> Parva Thole - </h5>
      <div>
            <p>
                An experienced political consultant with a solid foundation in strategy consulting, client management, team building, and project management.
                A graduate in Engineering from Birla Institute of Technology and science, Pilani – Goa Campus, with strong interests in philosophy, economics, and politics.
            </p>
            <p>
                With over four years of experience in project planning across diverse sectors, he has led teams, managed complex client relationships, and designed solutions that go beyond the conventional.
                But what truly defines him is his belief in purpose-driven leadership. Whether building teams or businesses, he leads with empathy, conviction, and vision.
            </p>
            <p>
                He is channeling his leadership and problem-solving skills into a mission that combines innovation with societal impact.
                For him, this venture is not just about success—it's about service, creating something that speaks to the future he envisions: thoughtful, inclusive, and transformative.
            </p>
        </div>  */}

        <h5> Dhirajkumar Mundhe - </h5>
        <div>
            <p>
                With over 8 years of experience in the social sector, he has been deeply committed to creating meaningful change at the grassroots level.
                His passion for community work led him to pursue a formal education in the field, completing his Master’s in Social Work from the reputed Karve Institute of Social Service, Pune.
            </p>
            <p>
                This academic grounding, combined with hands-on field experience,
                enabled him to design and implement impactful interventions across rural and urban communities.
            </p>
            <p>
                He has led several initiatives aimed at uplifting underprivileged populations through awareness, capacity building, and sustainable livelihood support.
                His strength lies in building strong community networks, collaborating with NGOs, and mobilizing CSR support to scale impact.
                He envisions a society where every individual has equal access to opportunities and resources for growth.
                Through his leadership, he continues to inspire change and build pathways for marginalized groups to lead self-reliant and dignified lives
            </p>
        </div> 
    </section>
    <section id="founder" className="container mb-5 founder-page">
        
      <h2 className="heading">Advisory Board</h2>

        <h5> Mr. Omkar Sathe - </h5>
        <div>
            <p>
                Omkar is a co-founder at CPC Analytics, an Indo-German public policy consulting
                firm. He leads diverse engagements with clients such as the World Health
                Organization, Government of Goa, National Skill Development Corporation, and
                Grasim Industries, focusing on AI-ML–driven fraud analytics, strategic policy
                advisory, and program evaluations. He has also served as a visiting faculty for public
                policy at FLAME University.
            </p>
            <p>
                Previously, he was Head of Innovation and New Products at UltraTech Cement. He
                has held strategy and marketing roles at Reliance Jio and Asian Paints. He holds an
                MBA from IIM Calcutta, an Executive Masters in Public Administration from the
                Hertie School of Governance, Berlin, and a Bachelors in Engineering from Pune
                University.
            </p>
        </div> 
        <h5> Utpal Das – </h5>
        <div>
            <p>
                Utpal is a seasoned banker with 33 years of diverse experience, retired as Assistant
                General Manager from Union Bank of India. A Certified Associate of IIBF, trained at
                ISB Hyderabad and NIBM Pune, he has led key roles in audit, planning, IT, and
                regional operations.
            </p>
            <p>
                He played a vital role in the amalgamation process of three
                banks, oversaw credit committees, and improved systems in audit, IT, and recovery.
                Academically, he is a National Scholarship recipient and topper in B.Sc. and M.Sc.
                (Agriculture). Post-retirement, he served as an advisor in the private sector and is
                currently engaged with an NGO in Pune.
            </p>
        </div> 
    </section>
    </>
  );
};

export default Founder;
